export const config = {
  baseUrl: process.env.REACT_APP_BASE_URL || 'http://localhost:3001',
  formscoreUrl:
    process.env.REACT_APP_FORMSCORE_URL || 'https://formscore.today',
};
